import request from '../../utils/request';
import options from './options';

const url = options.apiUrl;
const urlPath = path => `${url}${path}`;

export const getNutrition = id => request.get({
    url: urlPath(id),
    id
});

export const getNutritions = () => request.get({
    url
});

export const addNutrition = body => request.post({
    url: urlPath('create_calculation/'),
    body: body
});

export const updateNutrition = body => request.patch({
    url: urlPath(`${body.id}/update_calculation/`),
    body: body.values
});
